const STORAGE_KEY_PREFIX = "appointments-calendar-filter";

export interface PersistedCalendarFilterState {
  hidden?: string[];
  expanded?: boolean;
}

export function loadCalendarFilterState(workspaceId: string): PersistedCalendarFilterState | null {
  try {
    const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}-${workspaceId}`);
    if (!raw) return null;
    return JSON.parse(raw) as PersistedCalendarFilterState;
  } catch {
    return null;
  }
}

export function persistCalendarFilterState(
  workspaceId: string,
  state: PersistedCalendarFilterState,
): void {
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}-${workspaceId}`, JSON.stringify(state));
  } catch {
    /* ignore */
  }
}
